import { createContext } from "react";

export type SidebarState = "expanded" | "collapsed";

export type SidebarContextValue = {
  // Меню на компьютере: развёрнуто или свёрнуто до значков.
  state: SidebarState;
  toggle: () => void;
  // Шторка на телефоне.
  openMobile: boolean;
  setOpenMobile: (open: boolean) => void;
};

export const SidebarContext = createContext<SidebarContextValue | null>(null);
